import { render, staticRenderFns } from "./DisbursementType.vue?vue&type=template&id=b67cbea6&scoped=true"
import script from "./DisbursementType.vue?vue&type=script&lang=ts"
export * from "./DisbursementType.vue?vue&type=script&lang=ts"
import style0 from "./DisbursementType.vue?vue&type=style&index=0&id=b67cbea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67cbea6",
  null
  
)

export default component.exports